import React, {ReactNode} from 'react';

import FocusLock from 'react-focus-lock';

import {Paranja, Root, Sidebar, SidebarScrollable, Title} from './styled';

interface KeyboardEvent {
    key: string;
    stopPropagation: Function;
}

interface DrawerProps {
    children: ReactNode;
    onClose: () => void;
    open: boolean;
    title?: string;
}

export const Drawer = ({onClose, open, children, title}: DrawerProps) => (
    <>
        {open && (
            <Root
                onKeyDown={(evt: KeyboardEvent) => {
                    if (evt.key === 'Escape') {
                        evt.stopPropagation();
                        onClose();
                    }
                }}
            >
                <FocusLock>
                    <Paranja onClick={onClose} />
                    <Sidebar>
                        <SidebarScrollable>
                            {title && <Title>{title}</Title>}
                            {children}
                        </SidebarScrollable>
                    </Sidebar>
                </FocusLock>
            </Root>
        )}
    </>
);
